/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectManagementWizard/useRejectManagementEmailForm"/>
import { FieldValues, useForm } from "react-hook-form";
import { IRecipientAddress } from "./interfaces";

export interface RejectManagementEmailWizardFormState {
    emailTo: IRecipientAddress[];
    carbonCopy: IRecipientAddress[];
    messageSubject: string;
    sendCopy: boolean;
    content: string;
    sendToSupplier: boolean;
}

export const defaultState: RejectManagementEmailWizardFormState = {
    emailTo: [{value: ""}],
    carbonCopy: [{value: ""}],
    messageSubject: "",
    sendCopy: true,
    content: "",
    sendToSupplier: true,
};

export const useRejectManagementEmailForm = () => {
  const { handleSubmit, control, reset, watch, formState, setError, clearErrors, setValue, getValues } = useForm({
    criteriaMode: "all",
    mode: "onChange",
    defaultValues: defaultState as FieldValues,
    reValidateMode: "onChange",
  });

  return { handleSubmit, control, reset, watch, defaultState, formState, setError, clearErrors, setValue, getValues };    
};
